import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';

const getPostLaborUpdatesOnNats = createSelector(
  [getCompanySettings],
  (companySettings) => {
    return !!companySettings?.postLaborUpdatesOnNats;
  }
);

export { getPostLaborUpdatesOnNats };
